import { connect } from 'react-redux';
import CompareBucketComponent from './../components/CompareBucket';
import { MAX_SIZE_COMPARE_BUCKET } from './../constants';
import { addModelToCompareBucket } from './../actions';
import compareModelStore from './../storages/CompareModelStore';

const mapStateToProps = (state, ownProps) => ({
    MAX_SIZE: MAX_SIZE_COMPARE_BUCKET,
    id: state.compareBucket.currentModel.id,
    currentModel: state.compareBucket.currentModel,
    bucket: state.compareBucket.bucket
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    addModelToCompareBucket: (model) => {
        compareModelStore.addModelToBucket({
            id: model.id,
            displayName: model.name.displayName,
            brand: {
                displayName: model.name.brandName
            },
            supercategory:  {
                id: model.superCategoryId,
                pluralName: model.superCategoryName
            }
        });
        dispatch(addModelToCompareBucket(model));
    }
});

export const CompareBucket = connect(mapStateToProps, mapDispatchToProps)(CompareBucketComponent);



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/containers/CompareBucket.js